/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementreCAPTCHAIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementreCAPTCHAIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              d="M8.29293 4.02738H8.00001C6.61944 4.02738 5.36875 4.58757 4.46448 5.49185L5.17158 6.19895C5.89599 5.47455 6.8953 5.02738 8.00001 5.02738H8.29293L6.64648 6.67383L7.35359 7.38093L10.2071 4.52738L7.35359 1.67383L6.64648 2.38093L8.29293 4.02738Z"
              fill="currentColor"
            />
            <path
              d="M1.35359 10.3809L3.00004 8.73449V9.02738C3.00004 11.7888 5.23861 14.0274 8.00004 14.0274V13.0274C5.7909 13.0274 4.00004 11.2365 4.00004 9.02738V8.73449L5.64648 10.3809L6.35359 9.67383L3.50004 6.82027L0.646484 9.67383L1.35359 10.3809Z"
              fill="currentColor"
            />
            <path
              d="M12 9.32027L10.3536 7.67383L9.64648 8.38093L12.5 11.2345L15.3536 8.38093L14.6465 7.67383L13 9.32028V9.0276C13 7.64696 12.4398 6.39622 11.5354 5.49193L10.8284 6.19907C11.5528 6.92348 12 7.92284 12 9.0276V9.32027Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementreCAPTCHAIcon.tags = [
  'captcha',
  'verify',
  'security',
  'arrows',
  'reload',
  'refresh',
];

ElementreCAPTCHAIcon.category = 'Navigator';

ElementreCAPTCHAIcon.iconSize = 16;
